$.formUtils.addValidator({
	name : 'compareTo',
	validatorFunction : function(value, $el, config, language, $form) {
		var isValid;
		var data = $form.data('inputData');
		var mode = $el.data('validationCompareToMode') || 'date';
		var type = $el.data('validationCompareToType');
		var key = $el.data('validationCompareToKey');
		var force = $el.data('validationCompareToForce'); // force to evaluate comparison

		let errMsg = $el.attr('data-validation-error-msg-compare-to');
		if (errMsg != undefined) {
			$el.removeAttr('data-validation-error-msg-compare-to');
			$el.attr('data-validation-error-msg-compareTo', errMsg);
		}

		var thisValue = $el.val();
		var otherValue = data[key];
		if(!force && (thisValue == null || thisValue == '' || otherValue == null || otherValue == '')){
			// skip comparison if one of the fields is missing
			isValid = true
		} else {
			switch (mode) {
			case 'date':
				isValid = this.compareDates(thisValue, otherValue, type);
				break;
			case 'time':
				isValid = this.compareTimes(thisValue, otherValue, type);
				break;
			case 'string':
				isValid = this.compareStrings(thisValue, otherValue, type);
				break;
			default:
				console.log('validation mode not yet implemented:', mode);
			isValid = true;
			break;
			}
		}
		if(!isValid){
			this.errorMessage = xlate('common.validation.badCompareTo.' + mode + '.' + type + '.msg', {thisValue: thisValue, otherValue: otherValue});
		}
		return isValid;
	},
	compareDates: function(d1, d2, type){
		var momentPattern = 'DD/MM/YYYY';
		var field = 'day';
		switch (type) {
		case 'lt':
			return moment(d1, momentPattern).isBefore(moment(d2, momentPattern), field);
		case 'le':
			return !moment(d1, momentPattern).isAfter(moment(d2, momentPattern), field);
		case 'gt':
			return moment(d1, momentPattern).isAfter(moment(d2, momentPattern), field);
		case 'ge':
			return !moment(d1, momentPattern).isBefore(moment(d2, momentPattern), field);
		case 'eq':
			return moment(d1, momentPattern).isSame(moment(d2, momentPattern), field);
		case 'nq':
			return !moment(d1, momentPattern).isSame(moment(d2, momentPattern), field);
		default:
			return true;
		}
	},
	compareTimes: function(t1, t2, type){
		var momentPattern = 'HH:mm';
		var field = 'minute';
		switch (type) {
		case 'lt':
			return moment(t1, momentPattern).isBefore(moment(t2, momentPattern), field);
		case 'le':
			return !moment(t1, momentPattern).isAfter(moment(t2, momentPattern), field);
		case 'gt':
			return moment(t1, momentPattern).isAfter(moment(t2, momentPattern), field);
		case 'ge':
			return !moment(t1, momentPattern).isBefore(moment(t2, momentPattern), field);
		case 'eq':
			return moment(t1, momentPattern).isSame(moment(t2, momentPattern), field);
		case 'nq':
			return !moment(t1, momentPattern).isSame(moment(t2, momentPattern), field);
		default:
			return true;
		}
	},
	compareStrings: function(s1, s2, type){
		switch (type) {
		case 'lt':
			return s1 < s2;
		case 'le':
			return s1 <= s2;
		case 'gt':
			return s1 > s2;
		case 'ge':
			return s1 >= s2;
		case 'eq':
			return s1 === s2;
		case 'nq':
			return s1 !== s2;
		default:
			return true;
		}
	},
	errorMessage : 'This field must greater than {1}',
	errorMessageKey: ''
});
